export default __webpack_public_path__ + "static/media/amusement.dca58dc953351623a6fc38a413a9f404.jpg";